import type { Specialty } from "@/types/auth";
import type { FormEvent } from "react";

/** Must match `PrimaryPracticeArea` on POST /api/v2/public/waitlist. */
export const WAITLIST_PRIMARY_PRACTICE_OPTIONS = [
  "Independent Medical Examiner (Personal Injury)",
  "Qualified Medical Examiner (Worker's Comp)",
  "Medical Service",
  "Medical Malpractice",
  "Others",
] as const;

export type WaitlistPrimaryPractice = (typeof WAITLIST_PRIMARY_PRACTICE_OPTIONS)[number];

/**
 * Public waitlist API — matches POST /api/v2/public/waitlist (no password).
 */
export interface WaitlistSubmitPayload {
  email: string;
  name: string;
  organization_name: string;
  is_professional: boolean;
  specialty_id?: string;
  primary_practice_area: WaitlistPrimaryPractice;
  reports_per_month: number;
  pages_min: number;
  pages_max: number;
  case_flow_consistent: boolean;
  contact_phone: string;
  utm_source?: string;
}

export interface WaitlistSubmitResponse {
  message: string;
}

export interface WaitlistSurveyState {
  primaryPracticeArea: string;
  reportsPerMonth: string;
  pagesMin: string;
  pagesMax: string;
  caseFlowConsistent: boolean | null;
}

/** Client-side validation / inline field errors for the waitlist form. */
export interface WaitlistFormFieldErrors {
  email?: string;
  name?: string;
  organizationName?: string;
  specialty?: string;
  contactPhone?: string;
  primaryPracticeArea?: string;
  reportsPerMonth?: string;
  pages?: string;
  caseFlow?: string;
  general?: string;
}

export interface WaitlistViewProps {
  step: number;
  survey: WaitlistSurveyState;
  email: string;
  name: string;
  organizationName: string;
  isProfessional: boolean;
  specialtyId: string;
  contactPhone: string;
  specialties: Specialty[];
  isSubmitting: boolean;
  errors: WaitlistFormFieldErrors;
  onSurveyChange: (patch: Partial<WaitlistSurveyState>) => void;
  onEmailChange: (value: string) => void;
  onNameChange: (value: string) => void;
  onOrganizationNameChange: (value: string) => void;
  onIsProfessionalChange: (checked: boolean) => void;
  onSpecialtyIdChange: (value: string) => void;
  onContactPhoneChange: (value: string) => void;
  onNext: () => void;
  onBack: () => void;
  onSubmit: (e: FormEvent) => void;
}
